<template>
  <div>
    <NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
        <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
        <template v-else>
          <ICDForm :icd="extension" :extension="true" />
        </template>
			</v-container>
		</v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import ICDForm from "@/components/icd/ICDForm.vue";

export default {
  name: "NewICD",
  components: {
    NavBar,
    ICDForm
  },
  data: () => ({
    loading: false,
    extension: {
      code: "",
      information: {
        pt: {
          title: null,
          description: null
        },
        en: {
          title: null,
          description: null
        }
      }
    }
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: "ICD-11",
					disabled: false,
          link: true,
          to: "/admin/dashboard/icd"
        },
        {
					text: this.$gettext("New Extension"),
					disabled: true,
					link: true
				}
			];
		}
  }
}
</script>